/*
 * Home · FAQ accordion (sections/home-faq.liquid). Mirrors Replo's
 * collapsible: one answer open at a time (when data-hm-faq-exclusive is
 * "true"), 200ms height slide with cubic-bezier(0.4, 0, 0.2, 1).
 */
(function () {
  if (window.hmFaqLoaded) return;
  window.hmFaqLoaded = true;

  var ROOT = '[data-hm-faq]';
  var ITEM = '[data-hm-faq-item]';
  var TOGGLE = '[data-hm-faq-toggle]';
  var DURATION = 200;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function parts(item) {
    var button = item.querySelector(TOGGLE);
    var panel = button && document.getElementById(button.getAttribute('aria-controls'));
    return button && panel ? { button: button, panel: panel } : null;
  }

  function setOpen(item, open, animate) {
    var p = parts(item);
    if (!p) return;
    var isOpen = p.button.getAttribute('aria-expanded') === 'true';
    if (isOpen === open) return;

    var panel = p.panel;
    var from = panel.hidden ? 0 : panel.getBoundingClientRect().height;
    if (panel.hmAnimation) {
      panel.hmAnimation.cancel();
      panel.hmAnimation = null;
    }

    p.button.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.classList.toggle('is-open', open);
    panel.hidden = false;

    if (!animate || !panel.animate || reducedMotion()) {
      panel.hidden = !open;
      return;
    }

    var to = open ? panel.scrollHeight : 0;
    var animation = panel.animate([{ height: from + 'px' }, { height: to + 'px' }], {
      duration: DURATION,
      easing: EASING,
      fill: 'forwards',
    });
    panel.hmAnimation = animation;
    // The timer backs up onfinish, which can lag when the page isn't painting.
    function finish() {
      if (panel.hmAnimation !== animation) return;
      panel.hmAnimation = null;
      if (!open) panel.hidden = true;
      animation.cancel();
    }
    animation.onfinish = finish;
    setTimeout(finish, DURATION + 50);
  }

  function openItem(root, item, animate) {
    if (root.getAttribute('data-hm-faq-exclusive') === 'true') {
      root.querySelectorAll(ITEM).forEach(function (other) {
        if (other !== item) setOpen(other, false, animate);
      });
    }
    setOpen(item, true, animate);
  }

  function init(root) {
    if (root.hmFaqReady) return;
    root.hmFaqReady = true;

    root.addEventListener('click', function (event) {
      var button = event.target.closest(TOGGLE);
      if (!button || !root.contains(button)) return;
      var item = button.closest(ITEM);
      if (!item) return;
      if (button.getAttribute('aria-expanded') === 'true') {
        setOpen(item, false, true);
      } else {
        openItem(root, item, true);
      }
    });
  }

  function initAll(scope) {
    var container = scope || document;
    if (container.matches && container.matches(ROOT)) init(container);
    container.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Theme editor: selecting a question block opens it.
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest && event.target.closest(ITEM);
    var root = item && item.closest(ROOT);
    if (root) openItem(root, item, false);
  });
})();
